export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            关于97影院
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            致力于为全球华语用户提供最优质的免费观影体验
          </p>
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              97影院成立于2018年，是国内领先的免费电影在线观看平台。我们汇聚了超过十万部电影资源，涵盖动作、喜剧、科幻、悬疑、爱情、战争、动画、恐怖、纪录等多种类型，从好莱坞商业大片到独立文艺佳作，从华语经典到日韩热播，应有尽有。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              我们的使命是让每一个人都能轻松享受高品质的电影内容。所有影片均采用高清蓝光片源，配合先进的CDN加速技术，确保全国用户都能流畅观看，告别卡顿和缓冲。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed">
              片库每日更新，编辑团队精心策划各类专题合集，帮助您在海量影片中快速找到心头好。无论是周末宅家放松，还是寻找灵感启发，97影院都是您的观影首选。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}